import { Session } from "@chromia/ft4";
import { tDispatch } from "../store";
import { iParams } from "../../interfaces/chrInterfaces";
import { eChromiaActionTypes } from "./chromiaTypes";

/* export function set_chromia_account_details(account_details: iFullfilled_account_details) {
	return (dispatch : tDispatch) => {
		dispatch({
			type: chromia_action_types.SET_ACCOUNT_DETAILS,
			payload: account_details
		})
	}
} */

export const setChrUserAddress = (address: string | null) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_CHR_USER_ADDRESS,
			payload: address
		})
	}
}

/* export const setAssetBalance = (balances: iAssetBalance) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_TOKEN_BALANCES,
			payload: balances
		})
	}
} */

export const setChrParams = (params: iParams) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_PARAMS,
			payload: params
		})
	}
}

export const setSession = (session: Session | null) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eChromiaActionTypes.SET_SESSION,
			payload: session
		})
	}
}

export function setIsIniting(isIniting: boolean) {
    return (dispatch: tDispatch) => {
        dispatch({
            type: eChromiaActionTypes.SET_IS_INITING,
            payload: isIniting
        })
    }
}